import React, {Component} from 'react';
import axios from "axios";
import config from 'react-global-configuration';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import jwt_decode from "jwt-decode";
import "react-datepicker/dist/react-datepicker.css";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;


class IndexData extends Component{
    constructor(props) {
        super(props);
        this.state = {
            _notificationSystem: null,
            mapField: false,
            raw_display_data: [],
            isSubmit: false,
            loading: false
        }
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        //this._refreshTimestampView();
    }

    openSectionToMap = (status) => {
        this.setState({
            mapField: status
        })
    };

    _refreshTimestampView(){
        if ($.fn.DataTable.isDataTable('#timestamp_ViewTable')) {
            $('#timestamp_ViewTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/view_timestamp',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                file_id: 118
                //this.props.match.params.id
            }
        }).then(response => {
            this.setState({
                raw_display_data: response.data
            });
            $('#timestamp_ViewTable').DataTable();
            this.setState({
                loading: false
            });
        });
    }

    sendIndexRequest(){
        const data = new FormData();
        console.log(Date.now());
        data.append('time_stamp', Date.now());
        axios.post(config.get('API_URL') + "/brandemi/index_data", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                if(res.data.success){
                    this.handleNotificationClick("tr", 1, res.data.success);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                    
                } 
                else {
                    this.handleNotificationClick("tr", 3, res.data.error);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                }
            })
            .catch(err => { // then print response status
                console.log("error " + err);
                // this.handleNotificationClick("tr", 3, "Something Wrong!");
                // this.setState({
                //     isSubmit:false,
                //     loading:false
                // })
            })
    }

    changeActiver(index, checked) {
        //let status = true;
        //if(checked===true){ status = 1 } else { status = 0 }
        this.setState({
            activer: {...this.state.activer, [index]:checked }
        })
    }

    //sendBankMapping(){
    //    this.openSectionToMap(true);
    //}

    render(){
        let customStyles = {
            control: provided => ({
                ...provided,
                padding: "0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),

        };

        let flexBox = {
            display: 'flex'
        };

        let timestamp_View_data = this.state.raw_display_data.map((value, index) => {
            return (
                <tr key={index + 1}>
                <td>{index+1}</td>
                <td>{value.timestamp}</td>
                <td>{value.status}</td>
                </tr>
            );
        });

        return(
            <div className="card-query-builder">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <div className="col-md-12" >
                    <div className="card">
                        <div className="header">
                            <h4 className="title">Index Data</h4>
                            <hr/>
                        </div>
                        <div className= "content">              
                            <div className="row">
                                <div className="col-md-12">
                                    <button onClick={this.sendIndexRequest} className="btn btn-primary">Index Data</button>   
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="header">
                            <h4 className="title">Status of indexing requests</h4>
                            <hr/>
                        </div>
                        <div className= "content">
                            <div className="content table-full-width table-responsive">
                                <table className="table table-striped table-hover" id="timestamp_ViewTable">
                                    <thead>
                                        <tr>
                                            <th>Sr No.</th>
                                            <th>Index Request at</th>
                                            <th>Index Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {timestamp_View_data}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="footer">
                        <div className="stats"><i></i></div>                        
                    </div>                   
                </div>
            </div>
        );
    }
}

export default IndexData;